import { useLayoutEffect, useMemo } from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import Styles from './OfflineOverlay.module.scss'

export const OFFLINE_OVERLAY_CONTAINER_ID = 'offline-overlay-container-id'

export const PortalOfflineOverlay = () => {
  const renderContainer = useMemo(() => document.createElement('div'), [])

  useLayoutEffect(() => {
    const externalMount = document.getElementById(OFFLINE_OVERLAY_CONTAINER_ID)
    externalMount?.appendChild(renderContainer)

    return () => {
      externalMount?.removeChild(renderContainer)
    }
  }, [renderContainer])

  return ReactDOM.createPortal(<div className={cx(Styles.container)}></div>, renderContainer)
}
